module.exports = __webpack_public_path__ + "media/images/icons/icons_small/38_menwomansign-e6653b5e58a59746671651df60334610.png";